import styled from "styled-components";
import PROFILE_STUDENT_SVG from "assets/images/profile_student.svg";
import { hw } from "features/homework/homeworkUi";

interface StudentHeaderProps {
    name: string;
    content: string;
}

const StudentHeader = ({ name, content }: StudentHeaderProps) => {
    return (
        <Container>
            <ProfileImage src={PROFILE_STUDENT_SVG} alt="" />
            <ProfileContent>
                <Name>{name || "학생"}</Name>
                <Class>{content}</Class>
            </ProfileContent>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 18px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 16px;
    box-shadow: ${hw.shadow};
    flex-shrink: 0;
`;

const ProfileImage = styled.img`
    width: 56px;
    height: 56px;
    border-radius: 16px;
    background: ${hw.brandSoft};
    object-fit: contain;
    padding: 8px;
    box-sizing: border-box;
`;

const ProfileContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

const Name = styled.span`
    color: ${hw.text};
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.03em;
`;

const Class = styled.span`
    color: ${hw.textMuted};
    font-size: 13px;
    font-weight: 500;
`;

export default StudentHeader;
